import { AlarmChannel } from "apis/alarm-settings";
import React from "react";
import { MainPolicySettingBlock, PolicyCustomizeSection } from "uis/Section";
import UI from "@mile-meeting/mile-ui";
import { useToast } from "hook/useToast";

type ComplainNotificationSettingProps = {
  isActivated?: boolean;
  channel?: AlarmChannel;
  onChangeChannel?: (channel: AlarmChannel) => void;
  isSlackConnected?: boolean;
};
const ComplainNotificationSetting: React.FC<ComplainNotificationSettingProps> = ({
  isActivated = false,
  channel = AlarmChannel.EMAIL,
  onChangeChannel,
  isSlackConnected = false,
}) => {
  const { showToast } = useToast();
  if (!isActivated) return <></>;
  return (
    <PolicyCustomizeSection title="민원 알림">
      <MainPolicySettingBlock
        title="민원 알림 채널"
        description="설정한 채널로 민원 알림을 전송합니다. 민원 알림은 비활성화가 불가능합니다."
        rightChildren={
          <div style={{ display: "flex", gap: "20px" }}>
            <div style={{ display: "flex", gap: 4 }} onClick={() => onChangeChannel?.(AlarmChannel.EMAIL)}>
              <UI.Radio selected={channel === AlarmChannel.EMAIL} />
              <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
                E-mail
              </UI.Typography>
            </div>
            <div
              style={{ display: "flex", gap: 4 }}
              onClick={() => {
                if (isSlackConnected) onChangeChannel?.(AlarmChannel.SLACK);
                else showToast("Slack 미연동 상태입니다. 서비스 연동 관리에서 Slack을 연동해 주세요.", "warning");
              }}
            >
              <UI.Radio selected={channel === AlarmChannel.SLACK} disabled={!isSlackConnected} />
              <UI.Typography
                type="body01 normal"
                fontStyle="regular"
                color={isSlackConnected ? "var(--alias-color-label-normal)" : "var(--alias-color-label-disabled)"}
              >
                Slack
              </UI.Typography>
            </div>
          </div>
        }
      />
    </PolicyCustomizeSection>
  );
};

export default React.memo(ComplainNotificationSetting);
